import { DatePipe, TitleCasePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { MaskPipe } from '@modules/ngx-mask';
import { ColumnsTranslationService } from '@core/services/columns-translation.service';
import { ConfirmationService } from 'primeng/api';
import { AlertService } from '@smartera/core';
import { BreadcrumbService } from '@smartera/core';
import { LoadingService } from '@smartera/core';
import { LocalStorageService } from '@smartera/core';
import { LoginUserService } from '@smartera/core';
import { ProgressButtonService } from '@modules/components/progress-button/services/progress-button.service';

@Injectable({
	providedIn: 'root',
})
export class UtilityService {
	constructor(
		public builder: FormBuilder,
		public alertService: AlertService,
		public localStorageService: LocalStorageService,
		public confirmationService: ConfirmationService,
		public _translateService: TranslateService,
		public _breadcrumbServer: BreadcrumbService,
		public loginloader: LoadingService,
		public progressButtonServie: ProgressButtonService,
		public loginUserService: LoginUserService,
		public col: ColumnsTranslationService,
		public dateService: DatePipe,
		public maskService: MaskPipe,
		public titleCasePipe: TitleCasePipe
	) {}
}
